import React, { useState, useEffect, useRef } from 'react';
import './watchList.css';
import DashboardModal from './DashboardModal';
import { useDashboardModal } from './useDashboardModal';
import { useWatchList } from './useWatchList';

const WatchListRaceHistoryTable = () => {
  const {
    watchListListValue,
    watchListList,
    raceHistoryData,
    loading,
    handleGetWatchListDrivers,
    handleMyWatchListChange
  } = useWatchList();

  const { showDashboardModal, openModal, closeModal } = useDashboardModal();
  const [selectedCarClass, setSelectedCarClass] = useState("All");
  const isInitializedRef = useRef(false);

  const getUniqueCarClasses = () => {
    if (!raceHistoryData || raceHistoryData.length === 0) return [];
    const classes = [...new Set(raceHistoryData.map(race => race.carClass).filter(c => c && c !== "-"))];
    return classes.sort();
  };

  const uniqueCarClasses = getUniqueCarClasses();

  useEffect(() => {
    if (!isInitializedRef.current && uniqueCarClasses.length > 0) {
      if (uniqueCarClasses.length === 1) {
        setSelectedCarClass(uniqueCarClasses[0]);
      } else if (uniqueCarClasses.length > 1) {
        setSelectedCarClass("All");
      }
      isInitializedRef.current = true;
    }
  }, [uniqueCarClasses.length]);

  const filteredRaceData = selectedCarClass === "All"
    ? raceHistoryData
    : raceHistoryData.filter(race => race.carClass === selectedCarClass);

  const getDeltaDisplay = (currentValue, previousValue, metricType = 'time') => {
    if (!previousValue || previousValue === "-" || currentValue === "-") {
      return { value: "-", color: "#999" };
    }
    const current = parseFloat(currentValue);
    const previous = parseFloat(previousValue);
    if (isNaN(current) || isNaN(previous)) {
      return { value: "-", color: "#999" };
    }
    const delta = (current - previous).toFixed(3);
    let color = "#999";
    if (metricType === 'time') {
      color = delta < 0 ? '#27ae60' : delta > 0 ? '#e74c3c' : '#999';
    } else if (metricType === 'mph') {
      color = delta > 0 ? '#27ae60' : delta < 0 ? '#e74c3c' : '#999';
    }
    return {
      value: (delta > 0 ? '+' : '') + delta,
      color: color,
    };
  };


  const [fallbackRaceData] = useState([
    {
      date: "12-Oct-2024 14:23:45",
      round: "Round 1",
      category: "Street",
      win: true,
      opponentName: "John Smith",
      opponentCarNo: "456",
      dialIn: "6.790",
      rt: "0.056",
      ft60: "1.473",
      ft330: "4.366",
      ft8: "6.809",
      ft8mph: "100.220",
      ft1000: "-",
      ft4: "-",
      ft4mph: "-"
    },
    {
      date: "11-Oct-2024 15:45:30",
      round: "Round 2",
      category: "Street",
      win: false,
      opponentName: "Mike Johnson",
      opponentCarNo: "789",
      dialIn: "6.800",
      rt: "0.045",
      ft60: "1.455",
      ft330: "4.340",
      ft8: "6.795",
      ft8mph: "100.150",
      ft1000: "0.000",
      ft4: "0.000",
      ft4mph: "0.000"
    },
    {
      date: "10-Oct-2024 16:20:15",
      round: "Round 3",
      category: "Street",
      win: true,
      opponentName: "Sarah Davis",
      opponentCarNo: "234",
      dialIn: "6.785",
      rt: "0.062",
      ft60: "1.480",
      ft330: "4.375",
      ft8: "6.820",
      ft8mph: "100.100",
      ft1000: "-",
      ft4: "-",
      ft4mph: "-"
    },
    {
      date: "09-Oct-2024 13:55:00",
      round: "Round 1",
      category: "Pro",
      win: false,
      opponentName: "Alex Brown",
      opponentCarNo: "567",
      dialIn: "6.795",
      rt: "0.050",
      ft60: "1.468",
      ft330: "4.355",
      ft8: "6.810",
      ft8mph: "100.300",
      ft1000: "0.000",
      ft4: "0.000",
      ft4mph: "0.000"
    }
  ]);


  return (
    <div className="watch-list-wrapper">
      {/* Dropdown Section */}
      <div className="input-field-dropdown-wrapper">
        <div className="input-field-dropdown">
          <label htmlFor="SavedSearch">My WatchList:</label>
          <select
            id="SavedSearchSelect"
            value={watchListListValue}
            onChange={handleMyWatchListChange}
            onClick={handleGetWatchListDrivers}
          >
            <option value="0">{"-- Select an Option --"}</option>

            {watchListList.map((search) => (
              <option key={search.name} value={search.name}>
                {search.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Race History Table - shows when driver/car is selected */}
      {watchListListValue && watchListListValue !== "0" && (
      <>
        {/* Loading State */}
        {loading && (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <div className="loader"></div>
            <p style={{ color: '#666', marginTop: '10px' }}>Loading race history...</p>
          </div>
        )}

        {/* Dashboard Modal Component */}
        {showDashboardModal && (
          <DashboardModal
            isOpen={showDashboardModal}
            onClose={closeModal}
            driverName={watchListListValue}
            raceHistoryData={raceHistoryData}
          />
        )}

        {/* Race History Table */}
        {!loading && raceHistoryData.length > 0 && (
        <div className="race-history-table-container">
        <div className="race-history-header">
          <div className="header-content">
            <select
              className="carclass-dropdown"
              value={selectedCarClass}
              onChange={(e) => setSelectedCarClass(e.target.value)}
            >
              {uniqueCarClasses.length > 1 && (
                <option value="All">All Classes</option>
              )}
              {uniqueCarClasses.map((carClass) => (
                <option key={carClass} value={carClass}>
                  {carClass}
                </option>
              ))}
            </select>
            <h3>{watchListListValue}</h3>
          </div>
          {/* <button
            className="btn-open-dashboard"
            onClick={openModal}
          >
            📊 Dashboard
          </button> */}
        </div>
      <div className="race-history-table-wrapper">
        <table className="race-history-table">
          <thead>
            <tr>
              <th className="metric-col">Metric</th>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => (
                  <th key={idx} className="race-col">
                    Race {filteredRaceData.length - idx}
                  </th>
                ))
              ) : (
                <th className="race-col">Race 1</th>
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="metric-name">Date</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => {
                  const dateTimeParts = race.date.split(' ');
                  return (
                    <td key={idx} className="race-value">{dateTimeParts[0]}</td>
                  );
                })
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">Time</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => {
                  const dateTimeParts = race.date.split(' ');
                  return (
                    <td key={idx} className="race-value">{dateTimeParts[1]}</td>
                  );
                })
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">Round</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => (
                  <td key={idx} className="race-value">{race.round}</td>
                ))
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">Category</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => (
                  <td key={idx} className="race-value">{race.category}</td>
                ))
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">Car Class</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => (
                  <td key={idx} className="race-value">{race.carClass}</td>
                ))
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">Result</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => (
                  <td key={idx} className="race-value" style={{ color: race.win ? '#27ae60' : '#e74c3c', fontWeight: '700' }}>
                    {race.win ? 'WIN' : 'LOSS'}
                  </td>
                ))
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">Opponent</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => (
                  <td key={idx} className="race-value">{race.opponentName}</td>
                ))
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">Opp Car #</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => (
                  <td key={idx} className="race-value">{race.opponentCarNo}</td>
                ))
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">Dial-in Time</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => {
                  const previousRace = idx < filteredRaceData.length - 1 ? filteredRaceData[idx + 1] : null;
                  const delta = getDeltaDisplay(race.dialIn, previousRace?.dialIn, 'time');
                  return (
                    <td key={idx} className="race-value">
                      {race.dialIn}
                      <span style={{ color: delta.color, marginLeft: '4px', fontSize: '10px' }}>
                        [{delta.value}]
                      </span>
                    </td>
                  );
                })
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">Reaction Time</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => {
                  const previousRace = idx < filteredRaceData.length - 1 ? filteredRaceData[idx + 1] : null;
                  const delta = getDeltaDisplay(race.rt, previousRace?.rt, 'time');
                  return (
                    <td key={idx} className="race-value">
                      {race.rt}
                      <span style={{ color: delta.color, marginLeft: '4px', fontSize: '10px' }}>
                        [{delta.value}]
                      </span>
                    </td>
                  );
                })
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">60' Time</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => {
                  const previousRace = idx < filteredRaceData.length - 1 ? filteredRaceData[idx + 1] : null;
                  const delta = getDeltaDisplay(race.ft60, previousRace?.ft60, 'time');
                  return (
                    <td key={idx} className="race-value">
                      {race.ft60}
                      <span style={{ color: delta.color, marginLeft: '4px', fontSize: '10px' }}>
                        [{delta.value}]
                      </span>
                    </td>
                  );
                })
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">330' Time</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => {
                  const previousRace = idx < filteredRaceData.length - 1 ? filteredRaceData[idx + 1] : null;
                  const delta = getDeltaDisplay(race.ft330, previousRace?.ft330, 'time');
                  return (
                    <td key={idx} className="race-value">
                      {race.ft330}
                      <span style={{ color: delta.color, marginLeft: '4px', fontSize: '10px' }}>
                        [{delta.value}]
                      </span>
                    </td>
                  );
                })
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">1/8 Mile ET</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => {
                  const previousRace = idx < filteredRaceData.length - 1 ? filteredRaceData[idx + 1] : null;
                  const delta = getDeltaDisplay(race.ft8, previousRace?.ft8, 'time');
                  return (
                    <td key={idx} className="race-value">
                      {race.ft8}
                      <span style={{ color: delta.color, marginLeft: '4px', fontSize: '10px' }}>
                        [{delta.value}]
                      </span>
                    </td>
                  );
                })
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">1/8 Mile (MPH)</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => {
                  const previousRace = idx < filteredRaceData.length - 1 ? filteredRaceData[idx + 1] : null;
                  const delta = getDeltaDisplay(race.ft8mph, previousRace?.ft8mph, 'mph');
                  return (
                    <td key={idx} className="race-value">
                      {race.ft8mph}
                      <span style={{ color: delta.color, marginLeft: '4px', fontSize: '10px' }}>
                        [{delta.value}]
                      </span>
                    </td>
                  );
                })
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">1000' Time</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => {
                  const previousRace = idx < filteredRaceData.length - 1 ? filteredRaceData[idx + 1] : null;
                  const delta = getDeltaDisplay(race.ft1000, previousRace?.ft1000, 'time');
                  return (
                    <td key={idx} className="race-value">
                      {race.ft1000}
                      <span style={{ color: delta.color, marginLeft: '4px', fontSize: '10px' }}>
                        [{delta.value}]
                      </span>
                    </td>
                  );
                })
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">1/4 Mile ET</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => {
                  const previousRace = idx < filteredRaceData.length - 1 ? filteredRaceData[idx + 1] : null;
                  const delta = getDeltaDisplay(race.ft4, previousRace?.ft4, 'time');
                  return (
                    <td key={idx} className="race-value">
                      {race.ft4}
                      <span style={{ color: delta.color, marginLeft: '4px', fontSize: '10px' }}>
                        [{delta.value}]
                      </span>
                    </td>
                  );
                })
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
            <tr>
              <td className="metric-name">1/4 Mile (MPH)</td>
              {filteredRaceData.length > 0 ? (
                filteredRaceData.map((race, idx) => {
                  const previousRace = idx < filteredRaceData.length - 1 ? filteredRaceData[idx + 1] : null;
                  const delta = getDeltaDisplay(race.ft4mph, previousRace?.ft4mph, 'mph');
                  return (
                    <td key={idx} className="race-value">
                      {race.ft4mph}
                      <span style={{ color: delta.color, marginLeft: '4px', fontSize: '10px' }}>
                        [{delta.value}]
                      </span>
                    </td>
                  );
                })
              ) : (
                <td className="race-value">-</td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
        </div>
        )}

        {!loading && raceHistoryData.length === 0 && (
          <div style={{
            padding: '40px 20px',
            textAlign: 'center',
            color: '#999',
            fontSize: '16px',
            fontWeight: '500'
          }}>
            📭 No race history available for this driver
          </div>
        )}
      </>
      )}
    </div>
  );
};

export default WatchListRaceHistoryTable;
